import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 0H3.5C1.6 0 0 1.563 0 3.421v14.664c0 1.857 1.6 3.422 3.5 3.422H17c.6 0 1-.392 1-.978V.977C18 .391 17.6 0 17 0M3.5 1.955H16v12.708H3.5c-.5 0-1 .098-1.5.392V3.42c0-.782.7-1.465 1.5-1.465m0 17.596c-.8 0-1.5-.684-1.5-1.466s.7-1.466 1.5-1.466H16v2.932z"
    }, null, -1)
  ]))]))
}
export default { render: render }